import { originalGrid } from "../../../beforeAuth/components/user-dashboard-data/user-dashboard-data";
import { sharedPagesData } from "../../../beforeAuth/components/shared-pages-data/shared-pages-data";
const data = [
  {
    _id: 1,
    name: "Default",
    grid_json: originalGrid,
    module: "user",
    user_id: "1",
  },
];
export const state = {
  currentPage: 1,
  user_name: "",
  number: "",
  users: [],
  rows: [],
  loading: true,
  error: "",
  pages: data,
  grid: originalGrid,
  paginationModel: {
    pageNo: 1,
    limit: 20,
  },
  sharedPages: JSON.parse(
    localStorage.getItem("sharedPages") || JSON.stringify(sharedPagesData),
  ),
  pinToDashboardList: JSON.parse(
    localStorage.getItem("pinToDashboardList") || "[]",
  ),
  driveDashboard : data ,
};

export default state;
